import styled from "styled-components";
import { Collapse } from "antd";

export const Container = styled.div`
  min-height: 100vh;
  max-width: 100vw;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.colors.background};
`;

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  background-color: ${props => props.theme.colors.white};
  margin: 0 130px 80px 130px;
  border-radius: 16px;

  ${props => props.theme.mediaQuerie.maxWidth.lg}{
    margin: 0 48px 48px 48px;
  }

  ${props => props.theme.mediaQuerie.maxWidth.sm}{
    margin: 0;
    flex-direction: column;
  }
`;

export const NavMenu = styled.nav`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  padding: 32px;

  ${props => props.theme.mediaQuerie.maxWidth.sm}{
    padding: 16px;
  }
`;

export const Divider = styled.div`
  width: 1px;
  background-color: ${props => props.theme.colors.border};
`;

export const NavMenuItem = styled.button<{selected: boolean}>`
  padding: 12px;
  align-items: center;
  justify-content: start;
  text-align: start;
  border: none;
  width: fit-content;
  font-weight: ${props => props.selected ? 'bold' : 'normal'};
  background-color: ${props => props.selected ? props.theme.colors.inputBackground : 'transparent'};
  border: ${props => props.selected ? '1px solid' : 'none'};
  border-color: ${props => props.selected ? props.theme.colors.border : 'none'};
  border-radius: 8px;

  transition: all 0.5s;

  &:active, &:hover{
    background-color: ${props => props.theme.colors.inputBackground};
    cursor: pointer;
  }
`;

export const Section = styled.section`
  display: flex;
  flex: 4;
  flex-direction: column;
  padding: 48px;
  gap: 32px;
  background-color: "#EFF0F6";

  ${props => props.theme.mediaQuerie.maxWidth.sm}{
    padding: 32px;
  }
`;

export const FooterNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: auto; 
  padding-top: 92px;

  ${props => props.theme.mediaQuerie.maxWidth.sm}{
    gap: 16px;
    padding-top: 16px;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;

  >div {
    display: flex;
    width: 100%;
    gap: 16px;
    ${props => props.theme.mediaQuerie.maxWidth.sm}{
      flex-direction: column;
    }
  }

  text-align: center;

`;

export const PreviewButton = styled.div`
  display: flex;
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  border-radius: 24px;
  background: ${props => props.theme.colors.white};
  cursor: pointer;
  border: none;

  transition: all 0.5s;

  &:active {
    background: ${props => props.theme.colors.inputBackground};
  }
`;

export const HeaderNav = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 24px 130px;

  ${props => props.theme.mediaQuerie.maxWidth.lg}{
    padding: 48px;
  }

  ${props => props.theme.mediaQuerie.maxWidth.sm}{
    padding: 8px 10px;
  }

  >div {
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 16px;
  }
`;

export const StyledCollapse = styled(Collapse)`
  .ant-collapse-item {
    border: none;
    align-items: center;
    justify-content: start;
    text-align: start;
    width: fit-content;
    font-weight: bold;
    background-color: ${props => props.theme.colors.inputBackground};
    border-radius: 8px;
    width: 100%;
    margin-bottom: 16px;
    cursor: pointer;

    .ant-collapse-header { 
      padding: 16px;
    }

    .ant-collapse-content-box {
      padding: 0;
    }

    .ant-collapse-content {
      border: none;
    }
  }
  
  border: none;
`